import Vue from "vue";
import {
  getRequest,
} from "@/scripts/ProfiControlRequests/CrudManager";
import type {
  CardLimite,
} from "@/components/settings/scripts/CardLimite";

const fetchCardLimite = async (token: string)
    : Promise<{ response: CardLimite | undefined, errorCode: number | undefined}>  => {
    const url = `${Vue.prototype.$config.GatewayUrl}/api/v1/admin/card/limite`;
    let response = undefined;
    let errorCode = undefined;

    await getRequest<CardLimite>(url, token)
        .then((result) => {
            response = result.data;
        })
        .catch((result) => {
            errorCode = result.response.status;
        });

    return {
        response,
        errorCode
    };
};

export {
    fetchCardLimite
}
